export default __webpack_public_path__ + "static/media/icon-other-white.cffb83a8.svg";